import React, { useEffect } from "react";
import { Box, Paper, Tab, Tabs, Typography, withStyles, WithStyles } from "@material-ui/core";
import { UserDetailsForm } from "../../components/UserManagement/UserDetails/UserDetailsForm";
import { AddressesForm } from "../../components/UserManagement/Addresses/AddressesForm";
import { BillingForm } from "../../components/UserManagement/Billing/BillingForm";
import * as UserDetailsAction from "../../../stores/user/UserDetailsAction";
import { useDispatch, useSelector } from "react-redux";
import { styles } from "./AdminManageUsers.styles";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import ToastStatusEnum from "../../../constants/ToastStatusEnum";
import { useParams } from "react-router-dom";
import { Breadcrumbs } from "../../components/Breadcrumbs/Breadcrumbs";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";
import { SAPForm } from "../../components/UserManagement/SAP/SAPForm";

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

export interface IManageSpecifcUserProps extends WithStyles<typeof styles> {
}

const ManageSpecificUserViewPure: React.FunctionComponent<IManageSpecifcUserProps> = ({classes}) => {
    const [value, setValue] = React.useState(0);

    const dispatch = useDispatch();
    const {userId} = useParams();
    const userDetails = useSelector((state) => state.userDetails?.requestedUser);
    const {enqueueSnackbar} = useSnackbar();
    const {t} = useTranslation();

    useEffect(() => {
        dispatch(UserDetailsAction.requestUser(userId));
    }, [dispatch, userId]);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };

    const handleUserDetailsSave = (userDetails) => {
        dispatch(UserDetailsAction.editUser(userDetails)).then(() => {
            enqueueSnackbar(t("admin.manageUsersView.saved"), {variant: ToastStatusEnum.Info});
        })
        .catch(e => {
            enqueueSnackbar(`Saving user details failed - ${e.message}` , {variant: ToastStatusEnum.Error});
        })
    };

    const userTitle = userDetails?.email + (userDetails?.username ? (" - " + userDetails?.username) : "");

    return userDetails == null || userDetails.id !== userId
        ? null
        : <CenteredContainer>
            <Breadcrumbs
                items={[
                    {title: t("admin.adminPanel"), href: "/admin"},
                    {title: t("admin.manageUsersView.manageUsers"), href: "/admin/manage-users"},
                    {title: userDetails.firstName + " " + userDetails.lastName + " (" + userDetails.email + ")"}
                ]}
            />
            <div className={classes.header}>
                <Typography variant="h4">{t("admin.manageUsersView.manageUsers")}</Typography>
                <Typography variant="h5">Editing: {userTitle}</Typography>
            </div>
            <Paper square>
                <Tabs
                    value={value}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleChange}
                >
                    <Tab label="User details" />
                    <Tab label="Addresses" />
                    <Tab label="Billing information" />
                    <Tab label="SAP BP Information" />
                </Tabs>
                <TabPanel value={value} index={0}><UserDetailsForm onSave={handleUserDetailsSave}
                                                                   userDetails={userDetails} /></TabPanel>
                <TabPanel value={value} index={1}><AddressesForm onSave={handleUserDetailsSave}
                                                                 userDetails={userDetails} /></TabPanel>
                <TabPanel value={value} index={2}><BillingForm onSave={handleUserDetailsSave}
                                                               userDetails={userDetails} /></TabPanel>
                <TabPanel value={value} index={3}><SAPForm onSave={handleUserDetailsSave}
                                                               userDetails={userDetails} /></TabPanel>
            </Paper>
        </CenteredContainer>;
};

export const ManageSpecificUserView = withStyles(styles)(ManageSpecificUserViewPure);
